// ABOUTME: A labelled row of filter buttons with an "All" default, supporting single- and multi-select dimensions
// A labelled row of filter buttons: an "All" button (active when nothing is
// selected) plus one button per value. Selection is an array so a dimension can
// be multi-select; the parent decides toggle semantics (add/remove vs replace).
export function FilterChips({
  label,
  selected,
  options,
  onToggle,
  onClear,
  colorFor,
}: {
  label: string;
  selected: string[];
  options: string[];
  onToggle: (value: string) => void;
  onClear: () => void;
  colorFor?: (option: string) => string | undefined;
}) {
  return (
    <div className="filter-group" data-testid={`filter-group-${label.toLowerCase()}`}>
      <span className="filter-label">{label}</span>
      <div className="filter-chips">
        <button
          type="button"
          className={`filter-chip ${selected.length === 0 ? 'active' : ''}`}
          onClick={onClear}
        >
          All
        </button>
        {options.map((option) => {
          const active = selected.includes(option);
          const color = colorFor?.(option);
          return (
            <button
              key={option}
              type="button"
              className={`filter-chip ${active ? 'active' : ''}`}
              style={
                active && color
                  ? ({ '--chip-color': color } as React.CSSProperties)
                  : undefined
              }
              onClick={() => onToggle(option)}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}
